import { render, staticRenderFns } from "./IntelligentAnalysis.vue?vue&type=template&id=0a988620&scoped=true&"
import script from "./IntelligentAnalysis.vue?vue&type=script&lang=js&"
export * from "./IntelligentAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./IntelligentAnalysis.vue?vue&type=style&index=0&id=0a988620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a988620",
  null
  
)

export default component.exports